<template>
  <div id="page-wrapper">
    <div id="header2">
      <!-- Nav -->
      <nav id="nav">
        <img
          class="imagetran"
          src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/36571d0c027841b6a16ad96fa941f355.png"
          alt=""
          @click="goLink('Home')"
        />
        <ul>
          <li
            :class="currentRouteName == 'Home' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'Home' ? '100%' : '0',
            }"
          >
            <router-link to="/">
              <a> 首页</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'policy' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'policy' ? '100%' : '0',
            }"
          >
            <router-link to="/policy">
              <a>政策法规</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'vipBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'vipBox' ? '100%' : '0',
            }"
          >
            <router-link to="/vipBox">
              <a>会员单位</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'newBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'newBox' ? '100%' : '0',
            }"
          >
            <router-link to="/newBox">
              <a>新闻动态</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'contact' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'contact' ? '100%' : '0',
            }"
          >
            <router-link to="/contact">
              <a> 联系我们</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'About' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'About' ? '100%' : '0',
            }"
          >
            <router-link to="/About">
              <a>关于协会</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'signUp' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'signUp' ? '100%' : '0',
            }"
          >
            <router-link to="/signUp">
              <a> 护工培训</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'zhaogong' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'zhaogong' ? '100%' : '0',
            }"
          >
            <router-link to="/zhaogong">
              <a> 招工需求</a>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div class="imageBox">
      <div class="p1 animate__animated animate__zoomIn">护工培训</div>
      <!-- <div class="p2 animate__animated animate__zoomIn">
        协会护工培训动态，护工培训报名
      </div> -->
    </div>
    <div class="bannerBox2">
      <ul>
        <li>
          <a :class="type == 45 ? 'active' : ''" @click="get_newsList(45)"
            >培训通知</a
          >
        </li>
        <li>
          <a :class="type == 2 ? 'active' : ''" @click="get_newsList(2)"
            >培训报名</a
          >
        </li>
      </ul>
    </div>
    <div class="new_main_box" v-if="type == 45">
      <div class="new_top_box" v-if="list.length > 0">
        <div class="new_top_flex">
          <div class="p1"  @click="goDetails(list[0].id)">{{ list[0].title }}</div>
          <div class="p2">
            {{ list[0].remark1 }}
          </div>
          <div class="btn" @click="goDetails(list[0].id)">查看详情</div>
        </div>
        <div class="new_top_flex"  @click="goDetails(list[0].id)">
          <AnimatedImage
            class="image imagetran"
            :imageSrc="list[0].imageUrl ? list[0].imageUrl : src"
          />
        </div>
      </div>
      <div class="bottomBox">
        <template>
          <div
            class="bottom_flex"
            v-for="(item, index) in list"
            :key="index"
            @click="goDetails(item.id)"
          >
            <div class="bottom_img">
              <!-- <img
                class="image imagetran"
                :src="item.imageUrl ? item.imageUrl : src"
                alt=""
              /> -->
              <AnimatedImage
                class="image imagetran"
                :imageSrc="item.imageUrl ? item.imageUrl : src"
              />
            </div>
            <div class="bottom_text">
              <div class="p1">{{ item.title }}</div>
              <div class="p2">{{ item.remark1 }}</div>
              <div class="bottom_text_bottom">
                <div><i class="el-icon-top-right"></i></div>
                <div class="p3">{{ item.releaseTime | timeformat('short')}}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div style="text-align: center">
        <el-pagination
          background
          :current-page="pageNum"
          :page-sizes="[10, 20]"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
          style="float: right; margin: 10px 30px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @prev-click="handlePrevClick"
          @next-click="handleNextClick"
        />
      </div>
    </div>
    <div class="new_main_box" v-if="type == 2">
      <div class="title">
        <img src="" alt="" />
        <p class="p1">报名信息</p>
      </div>
      <div class="formBox">
        <el-form
          :model="formData"
          :rules="rules"
          ref="form"
          label-width="100px"
          class="form-body"
        >
          <div class="juBox">
            <div class="flexBox">
              <el-form-item label="培训对象" prop="type">
                <el-radio
                  style="margin-right: 20px"
                  v-model="formData.type"
                  label="1"
                  >企业报名</el-radio
                >
                <el-radio v-model="formData.type" label="2">个人报名</el-radio>
              </el-form-item>
            </div>
          </div>

          <template v-if="formData.type == 1">
            <div class="juBox">
              <div class="flexBox">
                <el-form-item label="企业名称" prop="companyName">
                  <el-input
                    v-model="formData.companyName"
                    placeholder="请输入您的企业名称"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="flexBox">
                <el-form-item label="培训人数" prop="nurseNum">
                  <el-input
                    v-model="formData.nurseNum"
                    placeholder="请输入培训人数"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="juBox">
              <div class="flexBox">
                <el-form-item label="拟培训时间" prop="trainingTime">
                  <el-date-picker
                    v-model="formData.trainingTime"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="timeChange"
                  />
                </el-form-item>
              </div>

              <div class="flexBox">
                <el-form-item label="联系方式" prop="phone">
                  <el-input
                    v-model="formData.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </template>

          <template v-if="formData.type == 2">
            <div class="juBox">
              <div class="flexBox">
                <el-form-item label="姓名" prop="personName">
                  <el-input
                    v-model="formData.personName"
                    placeholder="请输入您的姓名"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="flexBox">
                <el-form-item label="性别" prop="sex">
                  <el-radio
                    style="margin-right: 20px"
                    v-model="formData.sex"
                    label="1"
                    >男</el-radio
                  >
                  <el-radio v-model="formData.sex" label="2">女</el-radio>
                </el-form-item>
              </div>
            </div>
            <div class="juBox">
              <div class="flexBox">
                <el-form-item label="年龄" prop="age">
                  <el-input
                    v-model="formData.age"
                    placeholder="请输入年龄"
                  ></el-input>
                </el-form-item>
              </div>

              <div class="flexBox">
                <el-form-item label="联系方式" prop="phone">
                  <el-input
                    v-model="formData.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="juBox">
              <div class="flexBox">
                <el-form-item label="拟培训时间" prop="trainingTime">
                  <el-date-picker
                    v-model="formData.trainingTime"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="timeChange"
                  />
                </el-form-item>
              </div>
            </div>
          </template>
        </el-form>
        <div style="display: flex; justify-content: center">
          <div
            class="btn"
            :class="{ 'btn-disabled': isSubmitting }"
            @click="submitForm"
            :style="{ cursor: isSubmitting ? 'not-allowed' : 'pointer' }"
          >
            {{ isSubmitting ? "提交中..." : "提交信息" }}
          </div>
        </div>
      </div>
    </div>
    <About></About>
  </div>
</template>
    
    
    <script>
import AnimatedImage from "./AnimatedImage.vue";
import "../assets/css/main.css";
import "../assets/css/noscript.css";
import { newsList, HgAssociationTrain_add } from "../api/index";
import About from "./Footer.vue";
export default {
  name: "Home",
  components: {
    // 注册组件
    About,
    AnimatedImage,
  },
  data() {
    return {
      src: "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/3288746951724b2a82a91791d5e7e96d.png",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      type: 45,
      currentRouteName: "",
      formData: {},
      datails: {},
      formData: {
        type: "1",
        companyName: "",
        nurseNum: "",
        trainingTime: "",
        phone: "",
        comeTime: "",
        endTime: "",
        personName: "",
        sex: "1",
        age: "",
      },
      isSubmitting: false,
      rules: {
        type: [
          { required: true, message: "请选择培训对象", trigger: "change" },
        ],
        companyName: [
          {
            required: function () {
              return this.formData.type === "1";
            },
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        personName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        nurseNum: [
          { required: true, message: "请输入培训人数", trigger: "blur" },
        ],
        trainingTime: [
          { required: true, message: "请选择拟培训时间", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    goLink(name){
      this.$router.push({
        name: name,
      });
    },
    goDetails(id) {
      this.$router.push({
        name: "newDetails",
        query: {
          id: id,
          name: "培训通知",
          router: "signUp",
          image:
            "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/9434bb03a43a47269d439666993d569b.png",
        },
      });
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("form");
    },

    resetForm() {
      this.$refs.form.resetFields();
    },
    submitForm() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 这里可以将 formData 发送到后端接口，比如使用 axios.post('/api/submit', this.formData)
          console.log("表单提交成功", this.formData);
          const params = {
            ...this.formData,
          };
          params.accId = 1;
          delete params.trainingTime;
          HgAssociationTrain_add(params).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.resetQuery();
              this.isSubmitting = false;
            } else {
              this.isSubmitting = false;
            }
          });
        } else {
          console.log("表单验证失败");
          this.isSubmitting = false;
          return false;
        }
      });
    },
    timeChange(e) {
      console.log(e);
      this.formData.comeTime = e[0] + " 00:00:00";
      this.formData.endTime = e[1] + " 23:59:59";
    },
    isActive(path) {
      console.log(path, this.$route.path);
      return this.$route.path === path;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.get_newsList(this.type);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.get_newsList(this.type);
    },
    handlePrevClick() {
      this.pageNum--;
      this.get_newsList(this.type);
    },
    handleNextClick() {
      this.pageNum++;
      this.get_newsList(this.type);
    },
    get_newsList(type) {
      this.type = type;
      const params = {
        accId: 1,
        newType: type, //行业资讯,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      console.log(999, params);
      newsList(params, this.pageNum, this.pageSize).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.list = res.dataMap.list;
          this.total = res.dataMap.total;
        } else {
          this.$message(res.message);
        }
      });
    },
  },
  mounted() {
    this.currentRouteName = this.$route.name;
    this.get_newsList(45);

    // 添加 IntersectionObserver 逻辑
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains("animation-triggered")
        ) {
          entry.target.classList.add("fade-in", "animation-triggered");
        }
      });
    });

    const animatedElements = document.querySelectorAll(
      ".bannerBox2, .bannerBox2, .new_top_box, .bottomBox,.bottom_flex,.new_main_box"
    );
    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  },
  created() {},
};
</script>
    
  <style scoped>
html {
  font-size: 20px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0ba29a !important;
  color: #ffffff !important;
}

/deep/ .el-pagination button{
  width: 30px !important;
}

/* 动画样式 */
.fade-in {
  opacity: 1;
  transition: opacity 1s ease-in-out;
  transform: translateY(0);
  animation: fadeInUp 1s ease-in-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.el-pagination {
  float: none !important;
  font-size: 20px !important;
}

.active {
  color: #0ba29a !important;
  font-weight: 600;
}

.linkactive {
  color: #0ba29a !important;
  font-weight: 600;
}

.active1 {
  color: #ffffff;
}

.imageBox {
  background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/f7cd0ecfa43942a7994c2b076f41537a.png");
  background-size: 100% 100%;
  color: #fff;
  padding: 12em 18em 12em 18em;
  cursor: default;
  height: 560px;
  text-align: left;
}

.imageBox .p1 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 3em;
  color: #ffffff;
  margin-bottom: 50px;
}

.imageBox .p2 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 1.5em;
  color: #ffffff;
}

.new_main_box {
  padding: 2.5em 18em;
}

.new_top_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.new_top_flex {
  width: 29.4em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.new_top_flex .image {
  max-width: 100%;
  height: auto;
}

.new_top_flex .btn {
  position: relative;
  display: inline-block;
  background: #0ba29a;
  color: #fff;
  text-align: center;
  /* border-radius: 0.5em; */
  text-decoration: none;
  padding: 0.65em 3em 0.65em 3em;
  border: 0;
  cursor: pointer;
  outline: 0;
  font-weight: 300;
  width: 200px;
  border-radius: 5px;
  -moz-transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
  -webkit-transition: background-color 0.35s ease-in-out,
    color 0.35s ease-in-out, border-bottom-color 0.35s ease-in-out;
  -ms-transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
  transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
}

.new_top_flex .btn:hover {
  color: #fff;
  background: #097c76;
}

.new_top_flex .p1 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 1.3em;
  color: #333333;
  cursor: pointer;
}

.new_top_flex .p1:hover{
  color: #097c76;
}

.new_top_flex .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.8em;
  color: #666666;
  overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
}

.new_top_flex .btn {
  /* margin-top: 30px; */
}

.bottomBox {
  width: 100%;
  margin-top: 40px;
}

.bottom_flex {
  width: 100%;
  padding: 0.8em 0;
  display: flex;
  justify-content: start;
}

.bottom_img {
  width: 12em;
  height: 7.5em;
  margin-right: 1.995em;
}
.bottom_img .image {
  width: 12em;
  height: 7.5em;
}

.bottom_text {
  width: 61.81em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.bottom_text .p1 {
  font-family: PingFang SC;
  font-size: 1.3em;
  color: #333333;
  font-weight: 800;
  overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}

.bottom_text .p1:hover {
  color: #097c76;
  cursor: pointer;
}
.bottom_text .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.8em;
  color: #666666;
  overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.bottom_text .p2:hover {
  color: #097c76;
  cursor: pointer;
}

.bottom_text_bottom {
  display: flex;
  justify-content: space-between;
}
.bottom_text_bottom .image {
  width: 1.333em;
  height: 1.333em;
}
.bottom_text_bottom .p3 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.7em;
  color: #666666;
}

.bannerBox2 > ul {
  line-height: 80px;
  position: relative;
  display: inline-block;
  margin: 0;
  height: 80px;
  line-height: 80px;
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}

.bannerBox2 > ul:after {
  right: 100%;
  margin-right: 1px;
}

.bannerBox2 > ul > li {
  display: inline-block;
  margin: 0px 2em 0 2em;
  border: solid 1px transparent;
  -moz-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -webkit-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -ms-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  color: #333;
}

.bannerBox2 > ul > li > a,
.bannerBox2 > ul > li > span {
  display: block;
  color: inherit;
  text-decoration: none;
  border: 0;
  outline: 0;
}

.bannerBox2 > ul > li > a {
  display: block;
  color: #222222;
  text-align: center;
  text-decoration: none;
  position: relative;
}

.bannerBox2 > ul > li > a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #0ba29a;
  color: #0ba29a;
  transition: width 0.1s ease;
}

.bannerBox2 > ul > li > a:hover::after {
  width: 100%;
}

.bannerBox2 > ul > li > a:hover {
  color: #0ba29a;
  font-weight: 600;
}

.bannerBox2 > ul > li > a.current-page {
  color: #0ba29a;
  font-weight: 600;
}

.bannerBox2 > ul > li > ul {
  display: none;
}

.new_main_box .title {
  display: flex;
  justify-content: start;
}

.new_main_box .title .p1 {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 1.5em;
  color: #0ba29a;
}

.new_main_box .formBox .flexBox {
  width: 25.35em;
  background-color: #f7f7f7;
  padding: 0em 2em;
}

.new_main_box .formBox .btn {
  background: #0ba29a;
  font-family: PingFang SC;
  font-weight: 800;
  font-size: 1.25em;
  color: #ffffff;
  width: 10.7em;
  text-align: center;
  line-height: 52px;
  cursor: pointer;
  border-radius: 5px;
}

.btn-disabled {
  background-color: #a0a0a0;
  pointer-events: none;
}
.new_main_box .formBox .btn:hover {
  background: #097c76;
}

.juBox {
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 1.5em;
}

/deep/ .el-input__inner {
  border: none;
  background-color: #f7f7f7;
  /* 可以根据需要添加其他样式，比如下划线等 */
  /* border-bottom: 1px solid #ccc;  */
}

/deep/ form label {
  margin: 0;
}

/deep/ .el-form-item__label {
  color: #666666 !important;
}

/deep/ .el-input__inner:focus {
  background: #f7f7f7 !important;
}

/deep/ .el-form-item__label {
  color: #666666 !important;
  font-weight: 600;
}

/deep/ .el-form-item {
  margin: 0;
}

/deep/ .el-date-editor .el-range-input {
  background: none;
}

@media screen and (max-width: 1680px) {
  .imageBox{
    padding: 12em 10em 12em 10em;
  }
  .new_main_box{
    padding: 3em 10em;
  }
}

@media screen and (max-width: 1280px) {
  .imageBox{
    padding: 12em 10em 12em 10em;
  }
  .new_main_box{
    padding: 3em 10em;
  }
}

@media screen and (max-width: 960px) {
  .new_main_box {
    padding: 3.1em 2em;
  }
}

@media screen and (max-width: 840px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/f7cd0ecfa43942a7994c2b076f41537a.png");
    background-size: 100% 100%;
    color: #fff;
    padding: 12em 60px 12em 60px;
    cursor: default;
    height: 560px;
    text-align: center;
    line-height: 40px;
  }

  .new_top_box {
    flex-direction: column;
  }

  .new_top_flex:nth-child(1) {
    width: 100%;
    order: 2;
  }

  .new_top_flex:nth-child(2) {
    width: 100%;
    order: 1;
    margin-bottom: 20px;
  }

  .new_main_box {
    padding: 3.1em 2em;
  }

  .new_top_flex .p1 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 30px;
    color: #0ba29a;
  }

  .new_top_flex .p2 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #434343;
  }

  .new_top_flex .shareBox {
    display: inline-block;
  }

  .new_top_flex .shareBox .image {
    width: 15em;
    height: 15em;
    text-align: center;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 736px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/9434bb03a43a47269d439666993d569b.png");
    background-size: 100% 100%;
    color: #fff;
    padding: 12em 60px 12em 60px;
    cursor: default;
    height: 560px;
    text-align: center;
    line-height: 40px;
  }

  .new_top_box {
    flex-direction: column;
  }

  .new_top_flex:nth-child(1) {
    width: 100%;
    order: 2;
  }

  .new_top_flex:nth-child(2) {
    width: 100%;
    order: 1;
    margin-bottom: 20px;
  }

  .new_main_box {
    padding: 20px;
  }

  .new_top_flex .p1 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 1.5em;
    color: #0ba29a;
  }

  .new_top_flex .p2 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 1em;
    color: #434343;
  }

  .new_top_flex .shareBox .image {
    width: 15em;
    height: 15em;
    text-align: center;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .juBox {
    display: block;
  }

  .flexBox {
    margin-bottom: 1em;
  }
}
</style>
    
    